var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1034",
    width: 48,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1035"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1036"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f899c8",
    d: "M45.1 38.3c-.7.4-1.4 1.2-2 2.4-.5.9-.7 1.7-.6 2.3.1.6.4 1.1.8 1.3.4.2.9.2 1.4.1.5-.2 1-.6 1.5-1.2-.2-.6-.3-1.3-.2-2 .1-.7.3-1.3.6-1.9.2-.3.4-.6.6-1l-.2-.2c-.5-.3-1.2-.2-1.9.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f899c8",
    d: "m14.1 72.6 37 19.5c2 1.1 4.5.3 5.6-1.7l26.4-50c.6-1.1.6-2.3.2-3.4l-4.8-13.9c-.1-.3-.5-.5-.8-.4-4.2 1.5-8.1 1.8-10.5.9-1.4.6-3 .4-4.4-.7-1.2-1-1.7-2.7-1.3-4.1.9-3.4 5.5-4.4 7.7-1 .4.6.6 1.4.5 2.1-1.5-.1-2.4-.5-2.7-1.1-.3-.7-1.1-1-1.8-.7-.7.3-1 1.1-.7 1.7.3.8 1 1.5 1.9 2 2.6 1.4 7.2 1.1 12.1-.9 2.9-1.2 5.5-2.9 7.3-4.7 2-2.1 2.7-4.2 2-5.9-1-2.6-4.8-3.5-9.8-2.4-.7.2-1.2.9-1 1.6.2.7.9 1.2 1.6 1 3.8-.8 6.3-.2 6.7.8.3.7-.3 1.8-1.4 3.1-1.5 1.5-3.7 3-6.3 4-.2.1-.5.2-.7.3l-3-8.7c-.7-2-2.8-3.1-4.9-2.6l-27.6 7.5c-1.2.3-2.1 1-2.7 2.1L12.3 67c-1 2-.3 4.6 1.8 5.6zm46-13.8c-.1 1-.3 1.9-.8 2.8-.7 1.2-1.5 2.2-2.5 2.9-1 .7-2.1 1.1-3.2 1.2-1.1.1-2.2-.1-3.2-.7-1-.5-1.8-1.2-2.2-2.1-.4-.9-.6-1.8-.6-2.7.1-1 .4-1.9.8-2.8.7-1.3 1.5-2.3 2.5-3 1-.7 2.1-1.1 3.2-1.2 1.1-.1 2.2.1 3.2.7 1 .5 1.8 1.2 2.2 2.1.5.9.7 1.8.6 2.8zm-22.8-2.9c.2-.4.7-.9 1.3-1.2L52 46.4c-1.3-.2-2.4-.5-3.5-1-1 1-2.2 1.6-3.4 1.9-1.3.2-2.4.1-3.5-.5-1-.5-1.7-1.2-2.2-2.1-.4-.9-.6-1.8-.6-2.7.1-1 .3-1.9.8-2.8.7-1.3 1.5-2.2 2.5-3 1-.7 2.1-1.1 3.2-1.2 1.1-.1 2.2.1 3.2.7 1.3.7 2 1.7 2.3 2.9.3 1.3.2 2.6-.4 3.9 1.4.6 2.7 1 4.2 1 1.4 0 2.7-.3 3.7-.9 1-.6 1.8-.7 2.5-.3.4.2.7.6.8 1.1.1.5 0 1-.2 1.5s-.6.8-1.1 1.1L39.9 58.3c-.7.4-1.4.5-2 .1-.4-.2-.7-.6-.8-1-.2-.5-.1-1 .2-1.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f899c8",
    d: "M55.7 56.5c-.6-.3-1.2-.3-1.9.1s-1.4 1.2-2 2.4c-.5.9-.7 1.7-.6 2.3.1.6.4 1.1.9 1.3.5.3 1.2.2 1.9-.2s1.4-1.2 2-2.3c.5-.9.7-1.7.6-2.3-.1-.7-.4-1.1-.9-1.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrice);
export default __webpack_public_path__ + "static/media/icon-price.cb89af0b94cb7011bc474cd7c90e08cd.svg";
export { ForwardRef as ReactComponent };